import { render, staticRenderFns } from "./card.edit.input.component.vue?vue&type=template&id=473d0a0a"
import script from "./card.edit.input.component.vue?vue&type=script&lang=js"
export * from "./card.edit.input.component.vue?vue&type=script&lang=js"
import style0 from "./card.edit.input.component.vue?vue&type=style&index=0&id=473d0a0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports